// TODO: this will become deprecated.
// Move to another controller (didn't know where to put it yet)
// It's useuful to refresh a frame when the results change in the association overlay
// Eg: in the OptionType form

import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['toggle']

  static values = {
    turboFrame: String,
    turboVisitUrl: { type: String, default: window.location.href },
  }

  connect() {
    const turboFrame = document.getElementById(this.turboFrameValue)

    if (turboFrame && this.turboVisitUrlValue) {
      this.element.addEventListener("model-association-overlay:results-change", (e) => {
        e.stopPropagation()
        e.preventDefault()
        turboFrame.src = this.turboVisitUrlValue
      })
    }
  }

}
